import { Box } from '@bechtel/gds';
import styled from 'styled-components';
import { fullHDFormWidth, fullHDScreenWidth } from '~/utilities';

export const BoxStyled = styled(Box).attrs({
  py: { sm: '450' },
  gap: { sm: '800' },
  px: { sm: '700' },
  flexDirection: { sm: 'column' },
})`
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  @media only screen and (min-width: ${fullHDScreenWidth}) {
    width: ${fullHDFormWidth};
  }
`;
